import React from "react";
import { useSelector } from "react-redux";
import { LANDSCAPE } from "../../../config/Constant";
import GuestRequestDetails_Landscape from "./guestRequestDetail_landscape";
import GuestRequestDetails_Potrait from "./guestRequestDetail";


export const GuestRequestDetails = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    if (appOrientation == LANDSCAPE) {
        return <GuestRequestDetails_Landscape {...props} />;
    } else {
        return <GuestRequestDetails_Potrait {...props} />;
    }
}